import { Fragment, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { fetchDataFromApi, patchDataToTheServer, postDataToTheServer } from '../../../../widgets/api';
import { ToastSuccess } from '../../../../widgets/ToastMessage';
import AppURL from '../../../../widgets/AppURL';
import { Grid } from '@mui/material';
import ComponentHeading from '../../../../widgets/ComponentHeading';
import { IoAddCircle } from 'react-icons/io5';
import InputTextBox from '../../../../widgets/InputTextBox';
import NepaliInputTextBox from '../../../../widgets/NepaliInputTextBox';
import SelectionBox from '../../../../widgets/SelectionBox';
import {
  BookAuthorOptions,
  BookCategoryOptions,
  BookPublicationOptions,
  BookTypeOptions,
  IssuedForOptions,
  MajorSubjectOptions,
  MediumOptions,
  ProgramOptions,
  YearSemesterOptions,
} from '../../../../widgets/Options';
import {
  book_category_list,
  book_type_list,
  issued_for_list,
  item_category_list,
  lanugage_medium,
} from '../../../../widgets/json';
import { ClearBtn, SaveBtn, UpdateBtn } from '../../../../widgets/AppBtn';
import { NepNowDateFormat } from '../../../../widgets/DateFormat';
import Loading from '../../../../widgets/Loading';

const LibraryBookForm = ({ optionList, editBook, BookAddOptionListView, editedDetails, selectedBookIds }) => {
  const BookAuthorOption = BookAuthorOptions(optionList?.author_list);
  const BookPublicationOption = BookPublicationOptions(optionList?.publications_list);
  const MediumOption = MediumOptions(lanugage_medium);
  const IssuedForOption = IssuedForOptions(issued_for_list);
  const ItemCategoryOption = IssuedForOptions(item_category_list);
  const BookCategoryOption = IssuedForOptions(book_category_list);
  const BookTypeOption = BookTypeOptions(book_type_list);
  const BookKindOption = BookCategoryOptions(optionList?.category_list);
  const ProgramOption = ProgramOptions(optionList?.program_list);

  const [yearSemMajSub, setOnYearSemMajorSub] = useState([]);

  const YearSemesterOption = YearSemesterOptions(yearSemMajSub?.year_semester);
  const MajorSubjectOption = MajorSubjectOptions(yearSemMajSub?.major_subject);
  const NepNowDate = NepNowDateFormat();

  // FIX: ddc_no added to initialValues so formik tracks it properly
  const initialValues = {
    book_name: editedDetails?.book_name || '',
    book_name_nep: editedDetails?.book_name_nep || '',
    author: editedDetails?.author || '',
    orginal_price: editedDetails?.orginal_price || '0',
    actual_price: editedDetails?.actual_price || '0',
    page_no: editedDetails?.page_no || '0',
    book_category: editedDetails?.book_category || '',
    language: editedDetails?.language || '',
    book_pub: editedDetails?.book_pub || '',
    program: editedDetails?.program || '',
    edition: editedDetails?.edition || '0',
    remarks: '-',
    book_off: editedDetails?.book_off || false,
    book_type: editedDetails?.book_type || '',
    issued_for: editedDetails?.issued_for || 0,
    book_kind: editedDetails?.book_kind || '',
    branch_id: editedDetails?.branch_id || 1,
    book_volume: editedDetails?.book_volume || '0',
    major: editedDetails?.major || '',
    year_semester: editedDetails?.year_semester || '',
    life_percent: editedDetails?.life_percent || '0',
    bill_no: editedDetails?.bill_no || '0',
    call_no: editedDetails?.call_no || '0',
    isbn_no: editedDetails?.isbn_no ||'',
    item_category: editedDetails?.item_category ||'',
    ddc_no: editedDetails?.ddc_no || '', // FIX: was missing, caused uncontrolled input warning
  };
  const { values, errors, touched, resetForm, handleBlur, handleChange, setFieldValue, handleSubmit, isSubmitting } =
    useFormik({
      initialValues,
      enableReinitialize: true,
      onSubmit: async (values, action) => {
        const formData = new FormData();
        formData.append('book_name_nep', values.book_name_nep);
        formData.append('book_name', values.book_name);
        formData.append('author', values?.author);
        formData.append('orginal_price', values.orginal_price);
        formData.append('page_no', values.page_no);
        formData.append('book_category', values?.book_category);
        if (values?.item_category) {
          formData.append('item_category', values?.item_category);
        }
        formData.append('language', values?.language);
        formData.append('book_pub', values?.book_pub);
        if (values?.program) {
          formData.append('program', values?.program);
        }
        if (values?.year_semester) {
          formData.append('year_semester', values?.year_semester);
        }
        if (values?.major) {
          formData.append('major', values?.major);
        }
        formData.append('actual_price', values.actual_price);
        formData.append('edition', values.edition);
        formData.append('reg_date_n', NepNowDate);
        formData.append('remarks', values.remarks);
        formData.append('book_type', values?.book_type);
        formData.append('issued_for', values?.issued_for);
        if (values?.book_kind) {
          formData.append('book_kind', values?.book_kind);
        }
        formData.append('branch_id', 1);
        formData.append('life_percent', values.life_percent);
        formData.append('bill_no', values.bill_no);
        formData.append('call_no', values.call_no);
        formData.append('ddc_no', values.ddc_no);
        formData.append('isbn_no', values.isbn_no);
        formData.append('book_off', false);
        formData.append('book_ids', selectedBookIds);
        try {
          const res = await patchDataToTheServer(
            AppURL.LibraryURL + 'library-book-builk-retrieve-update-view/',
            formData
          );
          editBook(editedDetails?.book_id);
          ToastSuccess(res?.updated?.toString() + ' Book(s) updated successfully!');
          ClearForm();
          if (typeof BookAddOptionListView === 'function') BookAddOptionListView();
        } catch (error) {
          console.log(error);
        }
      },
    });

  const ClearForm = () => {
    resetForm();
  };

  const fetchYearSemesterMajorSubList = async () => {
    if (values?.program) {
      try {
        const res = await fetchDataFromApi(
          AppURL.AcademicsURL +
          'academic-student-year-semester-filter-list/?program_id=' +
          values?.program
        );
        setOnYearSemMajorSub(res);
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    fetchYearSemesterMajorSubList();
  }, [values?.program]);
  return (
    <Fragment>
      <form onSubmit={handleSubmit}>
        <Grid className="shadow mt-1 p-5 bg-white dark:bg-slate-800 rounded mb-3">
          <ComponentHeading label="Book Update" icon={IoAddCircle} />
          <Grid container columnSpacing={1} rowSpacing={1}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <InputTextBox
                name="isbn_no"
                type="text"
                label="Book ISBN"
                value={values.isbn_no}
                handleChange={handleChange}
                handleBlur={handleBlur}
                touched={touched.isbn_no}
                errors={errors.isbn_no}
                required={false}
                focus={true}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <InputTextBox
                name="book_name"
                type="text"
                label="Book Name"
                value={values.book_name}
                handleChange={handleChange}
                handleBlur={handleBlur}
                touched={touched.book_name}
                errors={errors.book_name}
                required={true}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <NepaliInputTextBox
                name="book_name_nep"
                label="Book Name (Nepali)"
                value={values.book_name_nep}
                onCustomValueChange={(field, value) => setFieldValue(field, value)}
                handleBlur={handleBlur}
                touched={touched.book_name_nep}
                errors={errors.book_name_nep}
                required={true}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <SelectionBox
                label="Author Name"
                name="author"
                value={values.author}
                handleBlur={handleBlur}
                options={BookAuthorOption}
                optionSelect={(fieldName, value) => { setFieldValue(fieldName, value); }}
                touched={touched.author}
                errors={errors.author}
                required={true}
                focus={true}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <SelectionBox
                label="Publisher Name"
                name="book_pub"
                value={values.book_pub}
                options={BookPublicationOption}
                handleBlur={handleBlur}
                optionSelect={(fieldName, data) => { setFieldValue(fieldName, data.value); }}
                touched={touched.book_pub}
                errors={errors.book_pub}
                required={true}
                focus={true}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <SelectionBox
                label="Book Kind"
                name="book_kind"
                value={values.book_kind}
                handleBlur={handleBlur}
                optionSelect={(fieldName, data) => { setFieldValue(fieldName, data.value); }}
                options={BookKindOption}
                touched={touched.book_kind}
                errors={errors.book_kind}
                required={true}
                focus={true}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <InputTextBox
                name="orginal_price"
                type="number"
                label="Original Price"
                value={values.orginal_price}
                handleChange={handleChange}
                handleBlur={handleBlur}
                touched={touched.orginal_price}
                errors={errors.orginal_price}
                required={false}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <InputTextBox
                name="actual_price"
                type="number"
                label="Actual Price"
                value={values.actual_price}
                handleChange={handleChange}
                handleBlur={handleBlur}
                touched={touched.actual_price}
                errors={errors.actual_price}
                required={false}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <InputTextBox
                name="life_percent"
                type="number"
                label="Life Percent"
                value={values.life_percent}
                handleChange={handleChange}
                handleBlur={handleBlur}
                touched={touched.life_percent}
                errors={errors.life_percent}
                required={false}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <InputTextBox
                name="page_no"
                type="number"
                label="Book Page No."
                value={values.page_no}
                handleChange={handleChange}
                handleBlur={handleBlur}
                touched={touched.page_no}
                errors={errors.page_no}
                required={true}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <InputTextBox
                name="bill_no"
                type="number"
                label="Bill No."
                value={values.bill_no}
                handleChange={handleChange}
                handleBlur={handleBlur}
                touched={touched.bill_no}
                errors={errors.bill_no}
                required={false}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <InputTextBox
                name="call_no"
                type="number"
                label="Call No."
                value={values.call_no}
                handleChange={handleChange}
                handleBlur={handleBlur}
                touched={touched.call_no}
                errors={errors.call_no}
                required={false}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <InputTextBox
                name="ddc_no"
                type="number"
                label="DDC No."
                value={values.ddc_no}
                handleChange={handleChange}
                handleBlur={handleBlur}
                touched={touched.ddc_no}
                errors={errors.ddc_no}
                required={false}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <SelectionBox
                label="Language"
                name="language"
                value={values.language}
                options={MediumOption}
                handleBlur={handleBlur}
                optionSelect={(fieldName, data) => { setFieldValue(fieldName, data.value); }}
                touched={touched.language}
                errors={errors.language}
                required={true}
                focus={true}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <InputTextBox
                name="edition"
                type="number"
                label="Edition"
                value={values.edition}
                handleChange={handleChange}
                handleBlur={handleBlur}
                touched={touched.edition}
                errors={errors.edition}
                required={true}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <SelectionBox
                label="Program"
                name="program"
                value={values.program}
                options={ProgramOption}
                handleBlur={handleBlur}
                optionSelect={(fieldName, data) => { setFieldValue(fieldName, data.value); }}
                touched={touched.program}
                errors={errors.program}
                required={false}
                focus={true}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <SelectionBox
                label="Year/Semester"
                name="year_semester"
                value={values.year_semester}
                options={YearSemesterOption}
                handleBlur={handleBlur}
                optionSelect={(fieldName, data) => { setFieldValue(fieldName, data.value); }}
                touched={touched.year_semester}
                errors={errors.year_semester}
                required={false}
                focus={true}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <SelectionBox
                label="Major Subject"
                name="major"
                value={values.major}
                options={MajorSubjectOption}
                handleBlur={handleBlur}
                optionSelect={(fieldName, data) => { setFieldValue(fieldName, data.value); }}
                touched={touched.major}
                errors={errors.major}
                required={false}
                focus={true}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <SelectionBox
                label="Book Type"
                name="book_type"
                value={values.book_type}
                options={BookTypeOption}
                handleBlur={handleBlur}
                optionSelect={(fieldName, data) => { setFieldValue(fieldName, data.value); }}
                touched={touched.book_type}
                errors={errors.book_type}
                required={true}
                focus={true}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <SelectionBox
                label="Book Category"
                name="book_category"
                value={values.book_category}
                options={BookCategoryOption}
                handleBlur={handleBlur}
                optionSelect={(fieldName, data) => { setFieldValue(fieldName, data.value); }}
                touched={touched.book_category}
                errors={errors.book_category}
                required={true}
                focus={true}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <SelectionBox
                label="Item Category"
                name="item_category"
                value={values.item_category}
                options={ItemCategoryOption}
                handleBlur={handleBlur}
                optionSelect={(fieldName, data) => { setFieldValue(fieldName, data.value); }}
                touched={touched.item_category}
                errors={errors.item_category}
                required={true}
                focus={true}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <SelectionBox
                label="Book Issue For"
                name="issued_for"
                options={IssuedForOption}
                value={values.issued_for}
                handleBlur={handleBlur}
                optionSelect={(fieldName, data) => { setFieldValue(fieldName, data.value); }}
                touched={touched.issued_for}
                errors={errors.issued_for}
                required={true}
                focus={true}
              />
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <InputTextBox
                name="remarks"
                type="text"
                label="Remarks"
                value={values.remarks}
                handleChange={handleChange}
                handleBlur={handleBlur}
                touched={touched.remarks}
                errors={errors.remarks}
                required={false}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* FIX: Use SaveBtn (not UpdateBtn) for a create/add form */}
        <div className="flex justify-end mt-4 pb-1 gap-3">
          <ClearBtn type="button" onClick={ClearForm} />
          <UpdateBtn disabled={isSubmitting} type="submit" />
        </div>
      </form>
      <Loading isSubmitting={isSubmitting} />
    </Fragment>
  );
};

export default LibraryBookForm;